import { render, staticRenderFns } from "./StockManagement.vue?vue&type=template&id=6f9a94f7"
import script from "./StockManagement.vue?vue&type=script&lang=js"
export * from "./StockManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports